import { API_URL } from "../config/connect";

const getGeoAnalytics = async () => {
    const endpoint = `${API_URL}/api/v1/analytics/geo`;
    const googleIdToken = localStorage.getItem("google_id_token");
    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${googleIdToken}`,
                "Content-Type": "application/json",
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        console.error('There was a problem fetching the geo analytics:', error);
        throw error;
    }
};

export default getGeoAnalytics;